import React from 'react';
import * as PropTypes from 'prop-types';
import {Group, Rect, Path} from 'react-konva';

// svgのpathのデータソース:/node_modules/@material-ui/icons/RotateRight.js
const PATH_DATA = 'M15.55 5.55L11 1v3.07C7.06 4.56 4 7.92 4 12s3.05 7.44 7 7.93v-2.02c-2.84-.48-5-2.94-5-5.91s2.16-5.43 5-5.91V10l4.55-4.45zM19.93 11c-.17-1.39-.72-2.73-1.62-3.89l-1.42 1.42c.54.75.88 1.6 1.02 2.47h2.02zM13 17.9v2.02c1.39-.17 2.74-.71 3.9-1.61l-1.44-1.44c-.75.54-1.59.89-2.46 1.03zm3.89-2.42l1.42 1.41c.9-1.16 1.45-2.5 1.62-3.89h-2.02c-.14.87-.48 1.72-1.02 2.48z';
const PATH_X = 0;
const PATH_Y = 2;
const PATH_FILL_COLOR = 'white';
const PATH_SCALE = {x: 1.5, y: 1.5};
const RECT_WIDTH = 36;
const RECT_HEIGHT = 36;
const RECT_FILL_COLOR = '#3f51b5'; // material-uiのprimaryボタンと同じ色.

export class RotationArrow extends React.Component {
    render() {
        return (
            <Group
                onTap={this.props.onTapOrClick}
                onClick={this.props.onTapOrClick}
                scaleX={this.props.scale}
                scaleY={this.props.scale}
                x={this.props.x}
                y={this.props.y}
            >
                <Rect // Pathのみの場合クリックしにくいので見えない矩形をクリックのトリガーに含める.
                    width={RECT_HEIGHT}
                    height={RECT_WIDTH}
                    fill={RECT_FILL_COLOR}
                />
                <Path
                    x={PATH_X}
                    y={PATH_Y}
                    data={PATH_DATA}
                    fill={PATH_FILL_COLOR}
                    scale={PATH_SCALE}
                />
            </Group>
        );
    }
}

RotationArrow.propTypes = {
    onTapOrClick: PropTypes.func.isRequired,
    scale: PropTypes.number,
    x: PropTypes.number,
    y: PropTypes.number
};

export default RotationArrow;
